import { useState } from "react";
import { getTextColor } from "@repo/utils";
import { HexColorPicker } from "react-colorful";

import { Button } from "./button";
import { Input } from "./input";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export const ColorPicker = ({
  value,
  onChange,
}: {
  value?: string;
  onChange: (color?: string) => void;
}) => {
  const [tempValue, setTempValue] = useState<string>(value ?? "");

  const [pickerOpen, setPickerOpen] = useState(false);

  const handleSubmit = () => {
    onChange(tempValue);
    setPickerOpen(false);
  };
  return (
    <Popover open={pickerOpen} onOpenChange={setPickerOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          style={{
            backgroundColor: value,
            color: getTextColor(value),
          }}
          className="w-full"
          variant="outline"
        >
          {value}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="gap-2 flex flex-col">
        <HexColorPicker
          className="!w-full"
          color={tempValue}
          onChange={(value) => {
            if (value === "#NaNNaNNaN") return;
            setTempValue(value);
          }}
        />
        <Input
          style={{
            backgroundColor: tempValue,
            color: getTextColor(tempValue),
          }}
          value={tempValue}
          onChange={(event) => {
            setTempValue(event.target.value);
          }}
        />
        <Button onClick={handleSubmit} variant="success">
          Done
        </Button>
      </PopoverContent>
    </Popover>
  );
};
